<div class="header-wrapper">
    <app-header [user]="userRoleObj" [isSuperAdminUser]="isSuperAdminUser" [isBranchAdminUser]="isBranchAdminUser"
        [isLOBUser]="isLOBUser" [isSearchedOfficeManagerUser]="isSearchedOfficeManagerUser" [teamInfo]="teamInfo"
        [searchAgentTeamInfo]="searchAgentTeamInfo" [searchAgentInfoForHeader]="searchAgentInfoForHeader"
        (onLogoClick)="showLandingPage()" (onPortalEmit)="onManage()" (onCoreEmit)="onCoreManage()"
        [officeManagerAgentSearch]="officeManagerAgentSearch" (onHomeEmit)="onHomeClick($event)"
        (onListClickEmit)="onListSearch($event)" [isAgentUser]="isAgentUser"
        [isOfficeManagerUser]="isOfficeManagerUser">
    </app-header>
</div>
<div class="section" *ngIf="userRoleObj && !xcelerateUser" [ngClass]="{'overlay-fix':adminAgentSearch || isDelegateUser}"
    (window:resize)="checkForDeviceType()" id="scrollTopDivAdmin">

    <app-admin-search (onSearchEmit)="onSearch($event)" [isMobileDevice]="isMobileDevice"
        [officeManagerAgentSearch]="officeManagerAgentSearch" [officeManagerOfficeList]="officeManagerOfficeList"
        [isBranchAdminUser]="isBranchAdminUser" [branchAdminOfficeList]="branchAdminOfficeList"
        (onClearEmit)="onClear()" *ngIf="(isSuperAdminUser || isBranchAdminUser || officeManagerAgentSearch || isDelegateUser) && 
((!isMobileDevice && showAgentInfo) || (isMobileDevice && showAgentInfo && !adminAgentSearch))">
    </app-admin-search>

    <div class="office-dropdown" *ngIf="isOfficeWebsiteEnabled">
        <div class="p-col-4 floating-form-group">
            <select class="floating-select" [disabled]="officeListForOfficeWebsite.length === 1"
                [(ngModel)]="selectedOfficeListForOfficeWebsite" name="officeWebsiteMenu"
                (change)="officeChangeEvent($event)">
                <option value="{{x?.id}}" *ngFor="let x of officeListForOfficeWebsite">{{x?.id}} - {{x?.value}}</option>
            </select>
            <label *ngIf="officeListForOfficeWebsite.length >  1">Select an Office</label>
        </div>
    </div>
    <app-core-employee-search
        *ngIf="(isSuperAdminUser || isLOBUser) && showCoreAssociationModule && ((!nonEmployeeEvent && isMobileDevice) || (!isMobileDevice)) && ((!employeeSearch && isMobileDevice) || (!isMobileDevice)) "
        (onAddNonEmployeeEmit)="addNonEmployee($event)" (searchEmployeeEmit)="searchForCoreEmployee($event)"
        (onAssignmentChangeEmit)="hideNonEmployee($event)" [isMobileDevice]="isMobileDevice">
    </app-core-employee-search>


    <div class="positionFooter" [ngClass]="{'fixed-footer':isFixedFooter}"
        *ngIf="(((isSuperAdminUser || isBranchAdminUser || officeManagerAgentSearch || isDelegateUser) && showAgentInfo && !adminAgentSearch) || (showCoreAssociationModule && !employeeSearch && !nonEmployeeEvent))">
        <app-footer [fullWidth]="true"></app-footer>        
    </div>


    <app-smart-menu
        *ngIf="(isSuperAdminUser || isBranchAdminUser || officeManagerAgentSearch || isLOBUser) && !showAdminView "
        [showCoreAssociationModule]="showCoreAssociationModule" (onPortalEmit)="onPortalClick($event)"
        (onCoreEmit)="onCoreServiceClick($event)" (onLogoClick)="showLandingPage()" (onHomeEmit)="onHomeClick($event)"
        (onListClickEmit)="onListSearch($event)"></app-smart-menu>

    <div *ngIf="isAgentUser  || (showCoreAssociationModule && (employeeSearch || nonEmployeeEvent)) || 
    (isOfficeManagerUser && !officeManagerAgentSearch) || (showAgentInfo && adminAgentSearch)"
        class="display-initial">

        <div class="menu-wrapper" *ngIf="!showCoreAssociationModule">
            <app-menu [isSearchedOfficeManagerUser]="isSearchedOfficeManagerUser"
                [officeManagerAgentSearch]="officeManagerAgentSearch"></app-menu>
        </div>


        <div class="sub-menu-wrapper"
            *ngIf="!url.includes('/portal/website-account') && !url.includes('/portal/website-listing') &&  !url.includes('/portal/office-showcase') && !url.includes('/portal/office-core-service') && !url.includes('/portal/team-website') && !showCoreAssociationModule">
            <app-personal-info-sub-menu *ngIf="isPersonalInfoEnabled"></app-personal-info-sub-menu>
            <app-subscription-sub-menu *ngIf="isSubscriptionEnabled"></app-subscription-sub-menu>
            <app-office-website-sub-menu *ngIf="isOfficeWebsiteEnabled"></app-office-website-sub-menu>
            <app-leads-crm-sub-menu *ngIf="isLeadsEnabled"></app-leads-crm-sub-menu>
        </div>
        <div class="sub-menu-wrapper" *ngIf="(isAgentUser|| isOfficeManagerUser || isSearchAgentTeamLeader) &&
             url.includes('/portal/team-website')  && !url.includes('/portal/team-website/teamlist') && (isTeamLeader || isSearchAgentTeamLeader)">
            <app-team-website-sub-menu *ngIf="isTeamWebsiteEnabled"></app-team-website-sub-menu>
        </div>
        <div class="container-wrapper" *ngIf="!showCoreAssociationModule"
             [ngClass]="{'wrapper-with-submenu':!url.includes('/portal/website-account')
             && !url.includes('/portal/website-listing') &&  !url.includes('/portal/office-showcase')  && !url.includes('/portal/team-website/teamlist')
              && !url.includes('/portal/office-core-service'),'wrapper-for-team-website': url.includes('/portal/team-website')  && !url.includes('/portal/team-website/teamlist')
              && !isTeamLeader && !isSearchAgentTeamLeader && !showCoreAssociationModule}">
            <div class="wrapper" [ngClass]="{'p-pt-0': isSuperAdminUser || isLOBUser}">
                <router-outlet></router-outlet>
            </div>
            <div class="positionFooter" [ngClass]="{'fixed-footer':isFixedFooter}">
                <app-footer></app-footer>
            </div>
        </div>
        <div *ngIf="showCoreAssociationModule" id="showCoreModule">
            <div class="wrapper" [ngClass]="{'p-pt-0': isSuperAdminUser || isLOBUser}">
                <router-outlet></router-outlet>
            </div>
            <div class="positionFooter" [ngClass]="{'fixed-footer':isFixedFooter}">
                <app-footer></app-footer>
            </div>
        </div>
    </div>
    <div *ngIf="showAdminView">

        <div *ngIf="(isBranchAdminUser && branchAdminOfficeList.length > 0) ||
             (officeManagerAgentSearch && officeManagerOfficeList.length > 0) ">
            <div class="primaryOfficeInfo"
                *ngIf="branchAdminOfficeList.length === 1 || officeManagerOfficeList.length === 1">
                <div class="" *ngIf="branchAdminOfficeList.length === 1">
                    <input class="primary-office-value" autocomplete="off" type="text"
                        [value]="branchAdminOfficeList[0].value" name="officename" disabled />
                    <span class="highlight"></span>
                    <label class="primary-office-heading">Branch Administrator</label>
                </div>
                <div class="" *ngIf="officeManagerOfficeList.length === 1">
                    <input class="primary-office-value" autocomplete="off" type="text"
                        [value]="officeManagerOfficeList[0].value" name="officename" disabled />
                    <span class="highlight"></span>
                    <label class="primary-office-heading">Office Manager</label>
                </div>
            </div>
            <div class="primaryOfficeInfo" *ngIf="branchAdminOfficeList.length > 1">
                <div class="">
                    <span class="primary-office-heading">Branch Administrator</span>
                </div>
            </div>
            <div class="primaryOfficeInfo" *ngIf="officeManagerOfficeList.length > 1">
                <div class="">
                    <span class="highlight"></span>
                    <span class="primary-office-heading">Office Manager</span>
                </div>
            </div>

        </div>


        <div class="container-wrapper admin-container-wrapper">
            <div class="wrapper admin-wrapper">
                <app-dashboard-menu (onManageBtn)="onManage()" (onCoreManageBtn)="onCoreManage()">

                </app-dashboard-menu>
            </div>
            <div class="positionFooter sticky-footer" [ngClass]="{'fixed-footer':isFixedFooter}">
                <app-footer [fullWidth]="true"></app-footer>
            </div>
        </div>
    </div>
</div>

<div *ngIf="xcelerateUser" class="section">
    <div class="display-initial">

        <div class="menu-wrapper">
            <app-menu></app-menu>
        </div>


        <div class="sub-menu-wrapper">
            <app-subscription-sub-menu></app-subscription-sub-menu>
        </div>

        <div class="container-wrapper wrapper-with-submenu">
            <div class="wrapper">
                <router-outlet></router-outlet>
            </div>
            <div class="positionFooter" [ngClass]="{'fixed-footer':isFixedFooter}">
                <app-footer></app-footer>
            </div>
        </div>
    </div>
</div>
<app-custom-confirm-dialogue [customClass]="'custom-modal'" [okBtnLabel]="'YES'" #confirmCancelModal
    [cancelBtnLabel]="'NO'" (onConfirm)="onConfirmSearch()">
</app-custom-confirm-dialogue>

<app-custom-confirm-dialogue [customClass]="'custom-modal'" [okBtnLabel]="'YES'" #confirmCancelEmployeeSearchModal
    [cancelBtnLabel]="'NO'" (onConfirm)="onConfirmSearchEmployee()">
</app-custom-confirm-dialogue>
<app-search-update-confirmation [customClass]="'custom-modal'" [okBtnLabel]="'Yes'" [cancelBtnLabel]="'No'"
    (onCancel)="onCancelConfirmNavigatePopup()" (onConfirm)="officeChangeEventConfirm()" #changeOfficeConfirmationModal>
</app-search-update-confirmation>
<app-search-update-confirmation [customClass]="'custom-modal'" [okBtnLabel]="'Yes'" [cancelBtnLabel]="'No'"
 (onConfirm)="redirectToNewPageConfirm()" #redirectToNewPage>
</app-search-update-confirmation>
